import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../FlowCollector.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NopCollectorClass;
function NopCollector() {
  if (NopCollectorClass === VOID) {
    class $ {
      *w1g(value, $completion) {
        return Unit_instance;
      }
      w1d(value, $completion) {
        return this.w1g(value, $completion);
      }
    }
    initMetadataForObject($, 'NopCollector', VOID, VOID, [FlowCollector()], [1]);
    NopCollectorClass = $;
  }
  return NopCollectorClass;
}
var NopCollector_instance;
function NopCollector_getInstance() {
  return NopCollector_instance;
}
//region block: init
NopCollector_instance = new (NopCollector())();
//endregion
//region block: exports
export {
  NopCollector_instance as NopCollector_instance2gq24j1mymjl3,
  NopCollector as NopCollector2h4omm21qc7hq,
};
//endregion

//# sourceMappingURL=NopCollector.mjs.map
